import colors from "@digits-shared/themes/colors"
import { m } from "framer-motion"
import { css, styled } from "styled-components"

export const DIGITS_BACKGROUND = css`
  background:
    fixed radial-gradient(ellipse at 38% 45%, rgba(222, 227, 223, 1) 0%, rgba(220, 226, 223, 0) 90%)
      no-repeat,
    linear-gradient(135deg, #a5cbe7, #9db9f0) repeat;
  background-size: cover;
`

export const DigitsEditBackground = styled(m.div)`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: -1;
  background:
    linear-gradient(to bottom, ${colors.translucentSecondary10}, ${colors.translucentSecondary20}),
    url(${require("static/images/reports/background-checkered.png")}) repeat;
`
